import React from 'react'
import {DecorativeCheckmarkIcon} from '@sbab-ui/icons';
import styles from './styles.module.scss';


const CheckList = ({ children }) => {
  if (!children || children.length === 0) {
    return null
  }
  return (
    <ul className={styles.checkList}>
      {children.map((item, i) => <li key={i} className={styles.item}><DecorativeCheckmarkIcon size={24}/> {item}</li>)}
    </ul>
  )
}

export { CheckList }
